// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2048k","empty":"ModalGraph_empty__7kGrZ"};